import React from "react";
import { ThemeProvider } from "react-jss";
import { theme } from "constants/Theme";
import { AmountContainer } from "../amount-container";
import { BannerProvider } from "../banner-provider/banner-provider";

export const AmountView = () => {
  return (
    <ThemeProvider theme={theme}>
      <BannerProvider>
        {(setBannerState) => (
          <AmountContainer setBannerState={setBannerState} />
        )}
      </BannerProvider>
    </ThemeProvider>
  );
};
export default AmountView;
